import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FaHome, FaChild, FaHeart, FaClipboardList, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const OyunTerapisi = () => {
  const benefits = [
    {
      icon: <FaHome />,
      title: "Güvenli Alan",
      description: "Çocuğunuz için özel olarak tasarlanmış güvenli bir terapi ortamı"
    },
    {
      icon: <FaChild />,
      title: "Gelişim Desteği",
      description: "Duygusal ve sosyal becerilerin gelişiminde profesyonel destek"
    },
    {
      icon: <FaHeart />,
      title: "Aile Danışmanlığı",
      description: "Süreç boyunca aile ile düzenli görüşmeler ve rehberlik"
    }
  ];

  const handleFormClick = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSc9gSoOOXkzc3jFoooShXgXw_nVUj1BsyVnHMjfSHuNmJjdKQ/viewform?usp=sharing&ouid=115317484010689908765', '_blank');
  };

  return (
    <div className="min-h-screen bg-label">
      <Helmet>
        <title>Oyun Terapisi Başvuru Formu | İstanbul Psikolog Yağmur Demiröz</title>
        <meta name="description" content="İstanbul'da oyun terapisi randevusu için online başvuru yapın. Çocuğunuzun duygusal ve sosyal gelişimini destekleyen profesyonel oyun terapisi hizmeti." />
        <meta name="keywords" content="oyun terapisi başvuru, çocuk psikoloğu randevu, istanbul oyun terapisti, online terapi başvuru" />
        <link rel="canonical" href="https://yagmurdemiroz.com/oyun-terapisi" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yagmurdemiroz.com/oyun-terapisi" />
        <meta property="og:title" content="Oyun Terapisi - Çocuğunuz İçin Güvenli Bir Alan" />
        <meta property="og:description" content="Çocuğunuzun duygusal ve sosyal gelişimini destekleyen profesyonel oyun terapisi. Güvenli ortamda uzman psikolog eşliğinde." />
        <meta property="og:image" content="https://yagmurdemiroz.com/me.jpg" />
        <meta property="og:locale" content="tr_TR" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalTherapy",
              "name": "Oyun Terapisi",
              "description": "Çocuklar için özel tasarlanmış psikolojik destek ve terapi hizmeti",
              "url": "https://yagmurdemiroz.com/oyun-terapisi",
              "provider": {
                "@type": "Psychologist",
                "name": "Psikolog Yağmur Demiröz",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "İstanbul",
                  "addressRegion": "Nispetiye/Etiler",
                  "addressCountry": "TR"
                },
                "telephone": "+90 544 135 47 54",
                "url": "https://yagmurdemiroz.com"
              },
              "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "url": "https://docs.google.com/forms/d/e/1FAIpQLSewyT2vKy06Yb2oTTJUcZClAhlLeiF2S7ehXpS0RdbUK1Qkig/viewform"
              }
            }
          `}
        </script>
      </Helmet>

      {/* Breadcrumb */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-2">
          <div className="flex items-center text-sm">
            <Link to="/" className="text-gray-600 hover:text-secondary">Ana Sayfa</Link>
            <FaChevronRight className="mx-2 text-gray-400" size={12} />
            <Link to="/calisma-alanlarim" className="text-gray-600 hover:text-secondary">Çalışma Alanlarım</Link>
            <FaChevronRight className="mx-2 text-gray-400" size={12} />
            <span className="text-secondary">Oyun Terapisi</span>
          </div>
        </div>
      </div>

      {/* New Call-to-Action Banner */}
      <div className="bg-secondary text-label py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <h2 className="text-xl font-semibold">Online başvuru formunu doldurarak randevu alabilirsiniz.</h2>
            </div>
            <button
              onClick={handleFormClick}
              className="bg-primary text-secondary px-6 py-3 rounded-md hover:opacity-90 transition-all duration-300 flex items-center font-medium"
            >
              <FaClipboardList className="mr-2" />
              Başvuru Formunu Doldur
            </button>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-start">
          <div className="w-full md:w-2/3 mb-6 md:mb-0">
            <h1 className="text-4xl font-bold text-secondary mb-6">
              Oyun Terapisi – Çocuklar İçin Profesyonel Terapi Desteği
            </h1>
            
            <div className="prose max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Oyun terapisi, çocukların doğal iletişim dili olan oyunu kullanarak duygusal ve davranışsal zorlukları ele alan etkili bir terapi yöntemidir.
              </p>

              <h2 className="text-2xl font-semibold text-secondary mb-4">Çalıştığım Alanlar</h2>
              <ul className="list-disc list-inside mb-6 text-gray-700 grid md:grid-cols-2 gap-2">
                <li>Korku, kaygı ve fobiler</li>
                <li>Takıntılar</li>
                <li>Alt ıslatma</li>
                <li>Ölüm, boşanma süreçleri</li>
                <li>Kardeş kıskançlığı</li>
                <li>Ayrılık kaygısı</li>
                <li>Uyku, yeme problemleri</li>
                <li>Özgüven eksikliği</li>
                <li>Doğum travmaları</li>
                <li>Okula gitme ve uyum problemleri</li>
                <li>Akran zorbalığı, sınırlar</li>
              </ul>

              <h2 className="text-2xl font-semibold text-secondary mb-4">Kimler İçin Uygundur?</h2>
              <ul className="list-disc list-inside mb-6 text-gray-700">
                <li className="mb-2">2-12 yaş arası çocuklar</li>
                <li className="mb-2">Yukarıdaki sorunlardan bir veya birkaçını yaşayan çocuklar</li>
                <li className="mb-2">Duygularını ifade etmekte zorlanan çocuklar</li>
                <li className="mb-2">Davranış değişikliği gösteren çocuklar</li>
              </ul>

              <div className="grid md:grid-cols-3 gap-6 my-8">
                {benefits.map((benefit, index) => (
                  <div key={index} className="bg-label p-6 rounded-lg border border-primary">
                    <div className="text-3xl text-secondary mb-4">{benefit.icon}</div>
                    <h3 className="text-xl font-semibold text-secondary mb-2">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.description}</p>
                  </div>
                ))}
              </div>

              <div className="space-y-6 mb-8">
                <div className="bg-label p-4 rounded-lg border border-primary">
                  <Link to="/moxo-testi" className="text-secondary hover:text-primary transition-colors">
                    MOXO Çocuk Testi ihtiyaç halinde randevu ile uygulanmaktadır.
                  </Link>
                </div>
                
                <div className="bg-label p-4 rounded-lg border border-primary">
                  <Link to="/ogrenci-danismanligi" className="text-secondary hover:text-primary transition-colors">
                    Okul başarısını desteklemek amacıyla öğrenci danışmanlığı süreci değerlendirilebilir.
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/3 md:ml-8">
            <div className="sticky top-24 bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-xl font-semibold text-secondary mb-4">
                Başvuru ve Randevu
              </h3>
              <p className="text-gray-700 mb-6">
                Online başvuru formunu doldurarak veya telefon ile iletişime geçerek randevu oluşturabilirsiniz.
              </p>
              <div className="space-y-4">
                <button
                  onClick={handleFormClick}
                  className="w-full text-center inline-block bg-secondary text-label py-3 px-6 rounded-md hover:opacity-90 transition-all duration-300"
                >
                  Başvuru Formunu Doldur
                </button>
                <a
                  href="tel:+905441354754"
                  className="w-full text-center inline-block bg-white text-secondary border border-secondary py-3 px-6 rounded-md hover:opacity-90 transition-all duration-300"
                >
                  Hemen Arayın
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OyunTerapisi;
